<template>
    <div class="blank-cell">
        <p class="tit">{{content.content}}</p>
        <input type="text" class="ipt" @blur='$emit("sendInput",{"itemInput":itemInput,"itemIndex":itemIndex})' v-model='itemInput' :readonly='answerStatus ? "readonly" : null '>
        <question-analyze v-if='answerStatus' :inside='content.analysis'></question-analyze>
    </div>
</template>
<script>

import QuestionAnalyze from "components/PC/QuestionAnalyze"
export default {
    name:"BlankCell",
    data(){
        return{
            itemInput:null
        }
    },
    created(){
        this.itemInput = this.content.answer
    },
    props:{
        content:{
            type:Object,
        },
        answerStatus:{
            type:Boolean
        },
        itemIndex:{
            type:Number
        }
    },
    components:{
        QuestionAnalyze,
    },
    methods:{

    }
}
</script>
<style lang="less" scoped>
.blank-cell{
    overflow: hidden;
    .tit{
        font-size:16px;
        color:#252631;
        padding:40px 0 10px;
        line-height:22px;
    }
    .ipt{
        display:block;
        width:100%;
        min-height:36px;
        border:none;
        border-bottom:1px solid #d9ddde;
        color:#7f8485;
        outline:none;
        margin-bottom:20px;
    }
}
</style>


